/* eslint-disable react/prop-types */
import { useStaticQuery, graphql } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = (props) => {
  const {
    lang,
    title,
    metaDesc,
    metaKeywords,
    metaRobotsNoindex,
    opengraphDescription,
    opengraphTitle,
    opengraphImage,
    opengraphUrl,
    hreflangs,
    schema,
  } = props;

  const {
    wp: { generalSettings: settings },
    site: {
      siteMetadata: { siteUrl, siteImage, siteLanguage, siteDescription },
    },
  } = useStaticQuery(graphql`
    query {
      wp {
        generalSettings {
          language
        }
      }
      site {
        siteMetadata {
          siteUrl
          siteImage
          siteLanguage
          siteDescription
        }
      }
    }
  `);

  const opengraphPreviewImage = opengraphImage
    ? siteUrl + getSrc(opengraphImage.localFile.childImageSharp)
    : siteUrl + siteImage;

  const isRobotsNoindexPage = metaRobotsNoindex === 'noindex';

  return (
    <Helmet
      title={title}
      htmlAttributes={{
        lang: lang || settings.language || siteLanguage,
        prefix: 'og: http://ogp.me/ns#',
      }}
    >
      {/* General */}
      <meta name="description" content={metaDesc || opengraphDescription || siteDescription} />
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {isRobotsNoindexPage && <meta name="robots" content="noindex" />}
      {/* Open Graph */}
      <meta property="og:url" content={siteUrl + opengraphUrl} />
      <meta property="og:title" content={opengraphTitle} />
      <meta
        property="og:description"
        content={opengraphDescription || metaDesc || siteDescription}
      />
      <meta property="og:image" content={opengraphPreviewImage} />
      <meta property="og:type" content="website" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {/*
          Canonical urls are added automatically with the gatsby-plugin-canonical-urls plugin
          <link rel="canonical" href="..." />
      */}
      {hreflangs &&
        Object.entries(hreflangs).map(([lang, href]) => (
          <link
            key={lang}
            rel="alternate"
            href={siteUrl + href}
            hrefLang={lang === 'default' ? 'x-default' : lang}
          />
        ))}
      {schema &&
        (Array.isArray(schema) ? (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        ) : (
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': schema.type,
              headline: title,
              image: opengraphPreviewImage,
              description: metaDesc,
              ...schema,
            })}
          </script>
        ))}
      {lang === 'ja' && <link rel="stylesheet" href="/styles/font-ja.css" />}
    </Helmet>
  );
};

export default SEO;
